import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product, onOpen, big = false, className = "", index = 0 }) => {
  const { add } = useCart();
  const quickAdd = (e) => {
    e.stopPropagation();
    add(product);
    toast(`${product.name} is in your cart`);
  };
  const spot = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      onMouseMove={spot} onClick={() => onOpen(product)} data-testid={`product-card-${product.id}`}
      className={`group relative overflow-hidden rounded-[22px] bg-[#170a24] border border-purple-400/15 cursor-pointer min-h-[340px] ${className}`}>
      <img src={product.image} alt={product.name} loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-[transform] duration-[1.4s] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0e0616] via-[#0e0616]/30 to-transparent" />
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: "radial-gradient(420px circle at var(--mx) var(--my), rgba(192,132,252,0.28), transparent 45%)" }} />
      <span className="absolute top-4 left-4 font-mono text-[11px] uppercase tracking-[0.25em] rounded-full bg-[#0e0616]/70 backdrop-blur px-3 py-1.5 text-purple-100">
        {product.intention}
      </span>
      <div className="absolute bottom-0 inset-x-0 p-5 md:p-6 flex items-end justify-between gap-4">
        <div>
          <h3 className={`font-display leading-none ${big ? "text-4xl md:text-5xl" : "text-2xl md:text-3xl"}`}>{product.name}</h3>
          <p className="mt-2 text-sm text-purple-200/90">{product.stone}</p>
          <p className="mt-3 font-mono text-amber-200" data-testid={`product-price-${product.id}`}>{money(product.price)}</p>
        </div>
        <button onClick={quickAdd} aria-label={`Add ${product.name} to cart`} data-testid={`product-quick-add-${product.id}`}
          className="shrink-0 w-12 h-12 rounded-full bg-purple-200 text-[#0e0616] grid place-items-center transition-[transform,background-color] duration-500 hover:bg-amber-200 hover:rotate-90">
          <Plus className="w-5 h-5" />
        </button>
      </div>
    </motion.article>
  );
};
